module.exports = __webpack_public_path__ + "static/img/190730-non-ivasive-testing.a8305ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gensunicerse/190730-non-ivasive-testing.jpg
// module id = s4wU
// module chunks = 0